<template>
    <div
        v-if="photoDialog"
        class="photo-dialog active"
        layout="row"
        layout-align="center center"
        @click="photoDialog = false"
    >
        <span
            class="icontainer"
            layout="row"
            layout-align="center center"
        >
            <img :src="src" />
        </span>
    </div>
</template>
<script>
export default {
  data () {
    return {
        photoDialog: false,
        src: null,
    }
  },
  mounted () {
    window.addEventListener("keyup", this.onEscapeKeyUp)
  },
  destroyed () {
    window.removeEventListener("keyup", this.onEscapeKeyUp)
  },
  methods: {
    onEscapeKeyUp (event) {
        if (event.which === 27) {
            this.photoDialog = false
        }
    },
    show(p){
        this.src = p
        this.photoDialog = true
    }
  }
}
</script>
<style lang="css" scoped>
.photo-dialog {
  position: relative;
  cursor: pointer;
  margin: 12px;
}

.photo-dialog.active {
  position: fixed;
  background-color: rgba(0, 0, 0, 0.75);
  margin: 0;
  z-index: 5;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.photo-dialog > .icontainer {
  text-align: center;
}
.photo-dialog.active > .icontainer {
  width: 100%;
  height: 100%;
}
.photo-dialog.active img {
  max-width: 100%;
  max-height: 100%;
  z-index: 8;
  margin: auto;
}
.photo-dialog > div {
  position: absolute;
  bottom: 5px;
  left: 0;
  right: 0;
  padding: 8px;
  color: white;
  background-color: rgba(0, 0, 0, 0.75);
  transition: opacity 0.3s ease-in-out;
  opacity: 0;
}
.photo-dialog > div > div {
  pointer-events: none;
}
.photo-dialog:hover > div {
  opacity: 1;
}
.photo-dialog.active > div {
  opacity: 1;
  top: 0;
  bottom: unset;
}
</style>